// src/components/Home/Clients.jsx
import React from "react";
import {
  FaIndustry,
  FaShoppingCart,
  FaLeaf,
  FaHardHat,
  FaMountain,
  FaClinicMedical,
  FaQuoteLeft,
  FaStar,
} from "react-icons/fa";
import "./Clients.css";

const Clients = () => {
  const clientIndustries = [
    {
      icon: <FaIndustry />,
      name: "Manufacturing",
      count: "50+",
      color: "#1a73e8",
    },
    {
      icon: <FaShoppingCart />,
      name: "Retail & E-commerce",
      count: "35+",
      color: "#fbbc04",
    },
    {
      icon: <FaLeaf />,
      name: "Agriculture",
      count: "25+",
      count: "25+",
      color: "#34a853",
    },
    {
      icon: <FaHardHat />,
      name: "Construction",
      count: "20+",
      color: "#ff6b35",
    },
    {
      icon: <FaMountain />,
      name: "Mining",
      count: "15+",
      color: "#8b5cf6",
    },
    {
      icon: <FaClinicMedical />,
      name: "Healthcare",
      count: "18+",
      color: "#ea4335",
    },
  ];

  const testimonials = [
    {
      quote:
        "Falmouth Global Solutions has been instrumental in streamlining our supply chain. Their customs clearance is fast and reliable.",
      author: "John Mwangi",
      company: "Manufacturing Director",
      rating: 5,
    },
    {
      quote:
        "Their air freight service saved our project timeline. The team is professional and always available to support our urgent needs.",
      author: "Sarah Kimani",
      company: "Project Manager",
      rating: 5,
    },
    {
      quote:
        "Excellent warehousing and distribution services. Our e-commerce business has grown thanks to their reliable logistics support.",
      author: "David Ochieng",
      company: "E-commerce Owner",
      rating: 5,
    },
  ];

  const clientLogos = [
    { name: "Manufacturing Partners", type: "manufacturing" },
    { name: "Retail Chains", type: "retail" },
    { name: "Agricultural Exporters", type: "agriculture" },
    { name: "Construction Firms", type: "construction" },
    { name: "Mining Companies", type: "mining" },
    { name: "Healthcare Providers", type: "healthcare" },
  ];

  return (
    <section className="clients-section section section-light">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center">
          <h2>Trusted by Leading Brands in Kenya</h2>
          <p className="section-subtitle">
            Manufacturers, distributors, retailers, NGOs and startups rely on
            our customs clearance and shipping services in Kenya
          </p>
        </div>

        {/* Client Industries */}
        <div className="client-industries">
          <h3 className="industries-title">Industries We Serve</h3>
          <div className="industries-grid">
            {clientIndustries.map((industry, index) => (
              <div key={index} className="industry-item card">
                <div
                  className="industry-icon"
                  style={{ color: industry.color }}
                >
                  {industry.icon}
                </div>
                <div className="industry-info">
                  <h4 className="industry-name">{industry.name}</h4>
                  <div className="industry-count">{industry.count} Clients</div>
                </div>
                <div
                  className="industry-highlight"
                  style={{ backgroundColor: industry.color }}
                ></div>
              </div>
            ))}
          </div>
        </div>

        {/* Client Logos Grid */}
        <div className="clients-showcase">
          <h3 className="showcase-title">Our Valued Clients</h3>
          <div className="logos-grid">
            {clientLogos.map((client, index) => (
              <div key={index} className="client-logo-card card">
                <div className="logo-placeholder">
                  <div className="logo-icon">
                    {clientIndustries[index].icon}
                  </div>
                  <span className="logo-text">{client.name}</span>
                </div>
                <div className="client-badge">Trusted Partner</div>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="testimonials-section">
          <h3 className="testimonials-title">What Our Clients Say</h3>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card card">
                <div className="testimonial-header">
                  <FaQuoteLeft className="quote-icon" />
                  <div className="rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} className="star-icon" />
                    ))}
                  </div>
                </div>
                <p className="testimonial-quote">"{testimonial.quote}"</p>
                <div className="testimonial-author">
                  <div className="author-info">
                    <strong>{testimonial.author}</strong>
                    <span>{testimonial.company}</span>
                  </div>
                </div>
                <div
                  className="testimonial-accent"
                  style={{
                    background: `linear-gradient(135deg, var(--ocean-blue), var(--yellow))`,
                  }}
                ></div>
              </div>
            ))}
          </div>
        </div>

        {/* Final CTA */}
        <div className="clients-cta">
          <div className="cta-card card">
            <div className="cta-content">
              <h3>Join Our Growing List of Satisfied Clients</h3>
              <p>
                Experience the Falmouth Global Solutions difference in logistics
                and supply chain management
              </p>
              <div className="cta-stats">
                <div className="cta-stat">
                  <div className="stat-number">150+</div>
                  <div className="stat-label">Happy Clients</div>
                </div>
                <div className="cta-stat">
                  <div className="stat-number">99.8%</div>
                  <div className="stat-label">On-Time Delivery</div>
                </div>
                <div className="cta-stat">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Support</div>
                </div>
              </div>
              <div className="cta-buttons">
                <button className="btn btn-primary btn-large">
                  Become a Client
                </button>
                <button className="btn btn-secondary btn-large">
                  Request Callback
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
